import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import {getDiamondImage, formatDiamondTitle, formatMeasurements, formatLocation, formatCut, formatCarat, formatCost, formatColor, formatPrice, formatClarity} from '../../../utils/formatting';

import * as storage from '../../../persistance/storage';

import AddDiamondConfirm from '../../common/alert/AddDiamondConfirm';

import * as leadsActionCreators from '../../../actions/leads';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, leadsActionCreators, usersActionCreators);

class AddToCard extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      card: null,
      cardInput: '',
      errorCard: null,

      displayAutocomplete: false,
      autocompleteLeads: [],

      serverError: null,
      sendingRequest: false,

      successCard: null,
      successAlertOpen: false,
    }

    // Fetch cards directory
    if(this.props.leads.directory === null) {
      this.props.fetchCardsDirectory()
      .then((respData) => {
        this.props.leadsSaveDirectory(respData.cards);
      })
      .catch((errorResp) => {
        // Do nothing; expected error if not logged in or correct role
        // console.error(errorResp);
      });      
    }

    this.authToken = storage.get('token');
    this.controllerAutocomplete = null;
	}

  componentDidUpdate(prevProps, prevState) {
    this.authToken = storage.get('token');
  }

  componentWillUnmount() {
    if(this.controllerAutocomplete) {
      this.controllerAutocomplete.abort();
    }
  }

  closeDropdown() {
    this.props.leadsCloseAddDropdown();
  }

  getRootClass() {
    return this.props.leads.dropdownOpen ? 'AddToCard open' : 'AddToCard';
  }

  refreshDirectory() {
    // Fetch cards directory
    if(this.props.leads.directory === null) {
      this.props.fetchCardsDirectory()
      .then((respData) => {
        this.props.leadsSaveDirectory(respData.cards);
        this.setAutocomplete();
      })
      .catch((errorResp) => {
        // Do nothing; expected error if not logged in or correct role
        // console.error(errorResp);
      });      
    }
  }

  setAutocomplete() {
    let suggestions = [];
    
    if(!this.state.cardInput || this.state.cardInput.length < 3) {
      return null;
    }

    const leadsFilter = {
      q: this.state.cardInput,
    };

    if(this.controllerAutocomplete) {
      this.controllerAutocomplete.abort();
    }
    const controllerAutocomplete = new AbortController();
    this.controllerAutocomplete = controllerAutocomplete;

    this.props.fetchAutocomplete(leadsFilter, this.authToken, controllerAutocomplete.signal)
    .then((respData) => {
      this.setState({ autocompleteLeads: respData.data });
    });    
  }

  changeCardInput(evt) {
    this.setState({ cardInput: evt.target.value }, () => {
      this.setAutocomplete();
    });
  }

  validateCardInput(evt) {
    if(this.state.card === null) {
      this.setState({
        errorCard: 'Please select a customer card',  
      });
    }
  }

  openAutocomplete() {
    this.setState({ displayAutocomplete: true }, () => {
      this.setAutocomplete();
    });
  }

  closeAutocomplete() {
    this.setState({ displayAutocomplete: false }); 
  }

  selectCard(card) {
    this.setState({
      card: card,
      recipientInput: '',
      displayAutocomplete: false,
      errorCard: null,
    });
  }

  removeCard() {
    this.setState({
      card: null,
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let errorCard = this.state.card === null ? 'Please select a customer' : null;

    if(errorCard === null) {
      hasErrors = false;
    }

    this.setState({
      errorCard: errorCard,
    });

    return !hasErrors;
  }

  handleSubmit() {
    if(this.validateAll()) {

      let diamond_ids = [];
      for(let i = 0; i < this.props.leads.dropdownDiamonds.length; i++) {
        diamond_ids.push(this.props.leads.dropdownDiamonds[i].id)
      }

      let addData = {
        card_id: this.state.card.id,
        diamonds: diamond_ids,
      }

      this.setState({
        sendingRequest: true,
        serverError: null,
      });

      this.props.leadsAddDiamonds(addData)
      .then((respData) => {
        
        // this.props.leadsAddShowConfirmation();
        this.props.leadsCloseAddDropdown();

        this.setState({
          sendingRequest: false,
          serverError: null,
          card: null,
          cardInput: '',
          errorCard: null,
          displayAutocomplete: false,
          autocompleteLeads: [],
          successAlertOpen: true,
          successCard: respData.card,
        });
      })
      .catch((errorResp) => {
        // console.error(errorResp);
        this.setState({
          sendingRequest: false,
          serverError: errorResp.message,
        });
      });
    }
  }

  getLeadDisplayName() {
    if(this.state.card) {
      return this.state.card.first_name + ' ' + this.state.card.last_name;
    }
    return '';
  }

  getLeadDisplayEmail() {
    if(this.state.card) {
      return this.state.card.email;
    }
    return '';
  }

  getDropdownTitle() {
    return 'Add to Customer Card';
  }

  closeSuccessPopup() {
    this.setState({ successAlertOpen: false });
  }

  cardNav() {
    this.setState({ successAlertOpen: false }, () => {
      if(!this.state.successCard) {
        history.push('/leads');
      } else {
        history.push('/customer/view/' + this.state.successCard.id);
      }
    });
  }

	render() {
		return <div className={this.getRootClass()}>
      <div className='innerWrapper'>
        <div className='closeIcon' onClick={this.props.leadsCloseAddDropdown.bind(this)}>&times;</div>
        <div className='newTitle'>{this.getDropdownTitle()}</div>
        <div className='recipientWrapper'>
          {this.state.card ?
            <div className='selectedRecipient'>
              <div className='nameWrapper'>{this.getLeadDisplayName()}</div>
              <div className='emailWrapper'>{this.getLeadDisplayEmail()}</div>
              <div className='removeCard' onClick={this.removeCard.bind(this)}>&times;</div>
            </div> :
            <div>
              <input 
                type='text'
                className={this.state.errorCard ? 'messageInput error' : 'messageInput'}
                value={this.state.cardInput}
                placeholder='First name, last name, email'
                onChange={this.changeCardInput.bind(this)}
                onFocus={this.openAutocomplete.bind(this)}
                onBlur={this.closeAutocomplete.bind(this)} />
              <div className={this.state.displayAutocomplete && this.state.autocompleteLeads && this.state.autocompleteLeads.length > 0 ? 'autocompleteWrapper open' : 'autocompleteWrapper'}>
                {this.state.autocompleteLeads.length === 0 ?
                  <div className={'autocompleteEntry nullAutocomplete'}>No matching cards found</div> :
                  <div>
                    {this.state.autocompleteLeads.map((card, i) => {
                      return <div className='autocompleteEntry' onClick={() => this.selectCard(card)} key={i}>
                        <div className='nameWrapper'>{card.first_name + ' ' + card.last_name}</div>
                        <div className={'emailWrapper EllipsisElement'}>{card.email_address}</div>
                      </div>
                    })}
                  </div>
                }
              </div>
            </div>
          }
        </div>
        {this.props.leads.dropdownDiamonds ?
          <div>
            {this.props.leads.dropdownDiamonds.map((diamond, i) => {
              return <div className='diamondWrapper' key={i}>
                <div className='diamondImageWrapper'>
                  <img src={getDiamondImage(diamond)} />
                </div>
                <div className='diamondBodyWrapper'>
                  <div className='diamondTitle'>{formatDiamondTitle(diamond)}</div>
                  <div className='diamondMeasurementRow'>
                    {diamond.measurements ? 
                      <div className='diamondMeasurements'>{formatMeasurements(diamond)}</div> :
                      null
                    }
                    <div className='diamondLocation'>
                      <div className='diamondLocationIcon'>
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                      <div className='diamondLocationName'>{formatLocation(diamond)}</div>
                    </div>
                  </div>
                  <div className='diamondInfoBlock'>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Cut:</div>
                      <div className='diamondInfoValue'>{formatCut(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Lab:</div>
                      <div className='diamondInfoValue'>{diamond.lab}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Carat:</div>
                      <div className='diamondInfoValue'>{formatCarat(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Cost:</div>
                      <div className='diamondInfoValue'>{formatCost(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Color:</div>
                      <div className='diamondInfoValue'>{formatColor(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Price:</div>
                      <div className='diamondInfoValue'>{formatPrice(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Clarity:</div>
                      <div className='diamondInfoValue'>{formatClarity(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>{diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
                      <div className='diamondInfoValue'></div>
                    </div>
                  </div>
                </div>
              </div>
            })}
          </div> :
          null
        }
        <div className='sendMessageWrapper'>
          <div 
            className={'actionButton sendButton'} 
            disabled={!this.state.sendingRequest} 
            onClick={this.handleSubmit.bind(this)}>Add to Card</div>
        </div>
      </div>
      <AddDiamondConfirm 
        open={this.state.successAlertOpen} 
        cardNav={this.cardNav.bind(this)}
        diamondsNav={this.closeSuccessPopup.bind(this)} />
    </div>;
	}
}
export default AddToCard;

function mapStateToProps(state) {
  return {
    leads: state.leads,
  };
}

export const AddToCardContainer = connect(
  mapStateToProps,
  allActionCreators
)(AddToCard);